export default theme => ({
  container: {
    maxWidth: 1200,
    margin: 'auto',
  },
});
